import * as yup from 'yup';
import { Controller, useForm } from 'react-hook-form'
//import { yupResolver } from '@hookform/resolvers/yup';

import {
  Box, Table, TableBody, TableCell, TableContainer,
  TableHead, TableRow, Paper, Button
} from '@mui/material';
import TextField from '@mui/material/TextField';
import { useDispatch, useSelector } from 'react-redux';
import { useState, useEffect } from 'react';
import AddIcon from '@mui/icons-material/Add';
import ModalApresentacaoProduto from '../components/ModalApresentacaoProduto';


const useStyles = () => ({
  gridItem: { margin: 8 },
  table: {
    minWidth: 1200,
  },
  tableContainer: {
    margin: 8,
    maxHeight: 600,
  },
  addButton: {
    margin: '16px 8px',
  },
  mainTitle: {
    margin: 15,
    fontWeight: 500,
    color: '#1976d2'
  },
  tableCell: {
    padding: '8px 4px',
    minWidth: 120
  },
  textField: {
    minWidth: 100,
    '& .MuiInputBase-input': {
      fontSize: '0.875rem'
    }
  }
});

const schema = yup.object().shape({
  medicamentos: yup.array().of(
    yup.object().shape({
      nomeComercialDCI: yup.string().required('Nome comercial/DCI é obrigatório'),
      // apresentacao: yup.string().required('Apresentação é obrigatória'),
      doseDiaria: yup.string().required('Dose diária é obrigatória'),
      viaLocalAdministracao: yup.string().required('Via de administração é obrigatória'),
      // dataToma: yup.string().required('Data da toma é obrigatória'),
      motivoTratamento: yup.string().required('Motivo do tratamento é obrigatório'),
      numeroLote: yup.string().required('Número do lote é obrigatório'),
      dataCaducidade: yup.string().required('Data de caducidade é obrigatória'),
      localCompra: yup.string().required('Local de compra é obrigatório'),
      inicioTratamento: yup.string().required('Início do tratamento é obrigatório'),
      terminoTratamento: yup.string().required('Término do tratamento é obrigatório'),
      apresentacaoDetalhes: yup.mixed(),
    })
  ).min(1, 'Adicione pelo menos um medicamento'),
});

interface MedicamentoData {
  nomeComercialDCI: string;
  apresentacao: string;
  doseDiaria: string;
  viaLocalAdministracao: string;
  dataToma: string;
  motivoTratamento: string;
  numeroLote: string;
  dataCaducidade: string;
  localCompra: string;
  inicioTratamento: string;
  terminoTratamento: string;
  apresentacaoDetalhes?: any; // Para armazenar o resultado do modal
}

interface FormData {
  medicamentos: MedicamentoData[];
}

export default function InformacaoMedicamento() {
  const classes = useStyles();
  const dispatch = useDispatch();

  // Inicializa uma tabela com 10 linhas vazias
  const initialMedicamentos = Array(1).fill(null).map((_, index) => ({
    nomeComercialDCI: '',
    apresentacao: '',
    doseDiaria: '',
    viaLocalAdministracao: '',
    dataToma: '',
    motivoTratamento: '',
    numeroLote: '',
    dataCaducidade: '',
    localCompra: '',
    inicioTratamento: '',
    terminoTratamento: ''
  }));

  const reduxData = useSelector((state: any) => state.informacoesMedicamento);
  const [formData, setFormData] = useState<FormData>(reduxData && reduxData.medicamentos && reduxData.medicamentos.length > 0 ? reduxData : {
    medicamentos: initialMedicamentos
  });

  const { control, formState: { errors }, trigger } = useForm({
    defaultValues: formData,
    //resolver: yupResolver(schema),
    mode: 'onChange'
  });

  const [modalIndex, setModalIndex] = useState<number | null>(null);

  // Função para adicionar mais uma linha na tabela
  const adicionarLinha = () => {
    setFormData({
      ...formData,
      medicamentos: [
        ...formData.medicamentos,
        {
          nomeComercialDCI: '',
          apresentacao: '',
          doseDiaria: '',
          viaLocalAdministracao: '',
          dataToma: '',
          motivoTratamento: '',
          numeroLote: '',
          dataCaducidade: '',
          localCompra: '',
          inicioTratamento: '',
          terminoTratamento: ''
        }
      ]
    });
  };

  const handleChange = (index: number, field: keyof MedicamentoData, value: string) => {
    const updatedMedicamentos = [...formData.medicamentos];
    updatedMedicamentos[index] = {
      ...updatedMedicamentos[index],
      [field]: value
    };

    setFormData({
      ...formData,
      medicamentos: updatedMedicamentos
    });
  };

  useEffect(() => {
    dispatch({
      type: 'informacoesMedicamento',
      payload: formData
    });
  }, [formData, dispatch]);

  // Escutar evento de validação
  useEffect(() => {
    const handleValidateStep = async (event: Event) => {
      const customEvent = event as CustomEvent;
      if (customEvent.detail?.stepIndex === 1) { // Este é o step 1
        const isValid = await trigger(); // Valida todos os campos

        // Enviar resultado da validação
        const resultEvent = new CustomEvent('validationResult', {
          detail: { isValid }
        });
        window.dispatchEvent(resultEvent);
      }
    };

    window.addEventListener('validateCurrentStep', handleValidateStep);

    return () => {
      window.removeEventListener('validateCurrentStep', handleValidateStep);
    };
  }, [trigger, formData, errors]);

  return (
    <Box>


      <TableContainer component={Paper} style={classes.tableContainer}>
        <Table style={classes.table} stickyHeader aria-label="tabela de medicamentos">
          <TableHead>
            <TableRow>

              <TableCell align="center" style={classes.tableCell}>N.º</TableCell>
              <TableCell align="center" style={classes.tableCell}>Nome comercial / DCI</TableCell>
              <TableCell align="center" style={classes.tableCell}>Apresentação</TableCell>
              <TableCell align="center" style={classes.tableCell}>Dose diária</TableCell>
              <TableCell align="center" style={classes.tableCell}>Via e local de administração</TableCell>
              <TableCell align="center" style={classes.tableCell}>Início do tratamento</TableCell>
              <TableCell align="center" style={classes.tableCell}>Término do tratamento</TableCell>
              {/* <TableCell align="center" style={classes.tableCell}>Data da toma</TableCell> */}
              <TableCell align="center" style={classes.tableCell}>Motivo do tratamento</TableCell>
              <TableCell align="center" style={classes.tableCell}>Número do lote</TableCell>
              <TableCell align="center" style={classes.tableCell}>Data de caducidade</TableCell>
              <TableCell align="center" style={classes.tableCell}>Local de compra</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {formData.medicamentos.map((medicamento, index) => (
              <TableRow key={index}>
                <TableCell align="center" style={classes.tableCell}>
                  {index + 1}
                </TableCell>
                <TableCell align="center" style={classes.tableCell}>
                  <Controller
                    name={`medicamentos.${index}.nomeComercialDCI`}
                    control={control}
                    render={({ field }) => (
                      <TextField
                        {...field}
                        // label="Nome Comercial / DCI"
                        fullWidth
                        // size="small"
                        variant="outlined"
                        error={!!errors?.medicamentos?.[index]?.nomeComercialDCI}
                        helperText={typeof errors?.medicamentos?.[index]?.nomeComercialDCI?.message === 'string' ? errors?.medicamentos?.[index]?.nomeComercialDCI?.message : ''}
                        onChange={e => {
                          field.onChange(e);
                          handleChange(index, 'nomeComercialDCI', e.target.value);
                        }}
                        value={medicamento.nomeComercialDCI}
                      />
                    )}
                  />
                </TableCell>
                <TableCell align="center" style={classes.tableCell}>
                  <Button
                    variant="outlined"
                    color="primary"
                    onClick={() => setModalIndex(index)}
                  >
                    Selecionar apresentação
                  </Button>
                  <div style={{ fontSize: 12, marginTop: 4 }}>
                    {/* Exibe um resumo das apresentações marcadas, se houver */}
                    {medicamento.apresentacaoDetalhes &&
                      Object.entries(medicamento.apresentacaoDetalhes)
                        .filter(([key, val]) => key.startsWith('identificacaoProductoApresentacaoProducto') && val === true)
                        .map(([key]) => key.replace('identificacaoProductoApresentacaoProducto', ''))
                        .join(', ')
                    }
                    {medicamento.apresentacaoDetalhes && medicamento.apresentacaoDetalhes.identificacaoProductoApresentacaoProductoOutros &&
                      ` (${medicamento.apresentacaoDetalhes.identificacaoProductoApresentacaoProductoOutros})`
                    }
                  </div>
                  {modalIndex === index && (
                    <ModalApresentacaoProduto
                      open={true}
                      onClose={() => setModalIndex(null)}
                      onConfirm={(result) => {
                        // Salva o resultado do modal no medicamento correspondente
                        const updated = [...formData.medicamentos];
                        updated[index].apresentacaoDetalhes = result;
                        // Opcional: pode montar um resumo para o campo apresentacao
                        updated[index].apresentacao = Object.entries(result)
                          .filter(([key, val]) => key.startsWith('identificacaoProductoApresentacaoProducto') && val === true)
                          .map(([key]) => key.replace('identificacaoProductoApresentacaoProducto', ''))
                          .join(', ');
                        setFormData({ ...formData, medicamentos: updated });
                        setModalIndex(null);
                      }}
                      initialValue={formData.medicamentos[index].apresentacaoDetalhes}
                    />
                  )}
                </TableCell>
                <TableCell align="center" style={classes.tableCell}>
                  <Controller
                    name={`medicamentos.${index}.doseDiaria`}
                    control={control}
                    render={({ field }) => (
                      <TextField
                        {...field}
                        // label="Dose Diária"
                        fullWidth
                        // size="small"
                        variant="outlined"
                        error={!!errors?.medicamentos?.[index]?.doseDiaria}
                        helperText={typeof errors?.medicamentos?.[index]?.doseDiaria?.message === 'string' ? errors?.medicamentos?.[index]?.doseDiaria?.message : ''}
                        onChange={e => {
                          field.onChange(e);
                          handleChange(index, 'doseDiaria', e.target.value);
                        }}
                        value={medicamento.doseDiaria}
                      />
                    )}
                  />
                </TableCell>
                <TableCell align="center" style={classes.tableCell}>
                  <Controller
                    name={`medicamentos.${index}.viaLocalAdministracao`}
                    control={control}
                    render={({ field }) => (
                      <TextField
                        {...field}
                        // label="Via/Local de Administração"
                        fullWidth
                        // size="small"
                        variant="outlined"
                        error={!!errors?.medicamentos?.[index]?.viaLocalAdministracao}
                        helperText={typeof errors?.medicamentos?.[index]?.viaLocalAdministracao?.message === 'string' ? errors?.medicamentos?.[index]?.viaLocalAdministracao?.message : ''}
                        onChange={e => {
                          field.onChange(e);
                          handleChange(index, 'viaLocalAdministracao', e.target.value);
                        }}
                        value={medicamento.viaLocalAdministracao}
                      />
                    )}
                  />
                </TableCell>

                <TableCell align="center" style={classes.tableCell}>
                  <Controller
                    name={`medicamentos.${index}.inicioTratamento`}
                    control={control}
                    render={({ field }) => (
                      <TextField
                        {...field}
                        type="date"
                        variant="outlined"
                        style={classes.textField}
                        InputLabelProps={{ shrink: true }}
                        inputProps={{ max: medicamento.terminoTratamento || undefined }}
                        error={!!errors?.medicamentos?.[index]?.inicioTratamento}
                        helperText={
                          typeof errors?.medicamentos?.[index]?.inicioTratamento?.message === "string"
                            ? errors?.medicamentos?.[index]?.inicioTratamento?.message
                            : ""
                        }
                        onChange={(e) => {
                          const value = e.target.value;

                          if (
                            medicamento.terminoTratamento &&
                            value > medicamento.terminoTratamento
                          ) {
                            return;
                          }

                          field.onChange(e);
                          handleChange(index, "inicioTratamento", value);
                        }}
                        value={medicamento.inicioTratamento}
                      />
                    )}
                  />
                </TableCell>

                <TableCell align="center" style={classes.tableCell}>
                  <Controller
                    name={`medicamentos.${index}.terminoTratamento`}
                    control={control}
                    render={({ field }) => (
                      <TextField
                        {...field}
                        type="date"
                        variant="outlined"
                        style={classes.textField}
                        InputLabelProps={{ shrink: true }}
                        inputProps={{ min: medicamento.inicioTratamento || undefined }}
                        error={!!errors?.medicamentos?.[index]?.terminoTratamento}
                        helperText={
                          typeof errors?.medicamentos?.[index]?.terminoTratamento?.message === "string"
                            ? errors?.medicamentos?.[index]?.terminoTratamento?.message
                            : ""
                        }
                        onChange={(e) => {
                          const value = e.target.value;

                          if (
                            medicamento.inicioTratamento &&
                            value < medicamento.inicioTratamento
                          ) {
                            return;
                          }

                          field.onChange(e);
                          handleChange(index, "terminoTratamento", value);
                        }}
                        value={medicamento.terminoTratamento}
                      />
                    )}
                  />
                </TableCell>

                {/* <TableCell align="center" style={classes.tableCell}>
                  <TextField
                    type="date"
                    size="small"
                    variant="outlined"
                    style={classes.textField}
                    InputLabelProps={{ shrink: true }}
                    value={medicamento.dataToma}
                    onChange={(e) => handleChange(index, 'dataToma', e.target.value)}
                  />
                </TableCell> */}
                <TableCell align="center" style={classes.tableCell}>
                  <Controller
                    name={`medicamentos.${index}.motivoTratamento`}
                    control={control}
                    render={({ field }) => (
                      <TextField
                        {...field}
                        // label="Motivo do Tratamento"
                        fullWidth
                        // size="small"
                        variant="outlined"
                        error={!!errors?.medicamentos?.[index]?.motivoTratamento}
                        helperText={typeof errors?.medicamentos?.[index]?.motivoTratamento?.message === 'string' ? errors?.medicamentos?.[index]?.motivoTratamento?.message : ''}
                        onChange={e => {
                          field.onChange(e);
                          handleChange(index, 'motivoTratamento', e.target.value);
                        }}
                        value={medicamento.motivoTratamento}
                      />
                    )}
                  />
                </TableCell>
                <TableCell align="center" style={classes.tableCell}>
                  <Controller
                    name={`medicamentos.${index}.numeroLote`}
                    control={control}
                    render={({ field }) => (
                      <TextField
                        {...field}
                        // label="Número do Lote"
                        fullWidth
                        // size="small"
                        variant="outlined"
                        error={!!errors?.medicamentos?.[index]?.numeroLote}
                        helperText={typeof errors?.medicamentos?.[index]?.numeroLote?.message === 'string' ? errors?.medicamentos?.[index]?.numeroLote?.message : ''}
                        onChange={e => {
                          field.onChange(e);
                          handleChange(index, 'numeroLote', e.target.value);
                        }}
                        value={medicamento.numeroLote}
                      />
                    )}
                  />
                </TableCell>
                <TableCell align="center" style={classes.tableCell}>
                  <Controller
                    name={`medicamentos.${index}.dataCaducidade`}
                    control={control}
                    render={({ field }) => (
                      <TextField
                        {...field}
                        type="date"
                        // size="small"
                        variant="outlined"
                        style={classes.textField}
                        InputLabelProps={{ shrink: true }}
                        error={!!errors?.medicamentos?.[index]?.dataCaducidade}
                        helperText={typeof errors?.medicamentos?.[index]?.dataCaducidade?.message === 'string' ? errors?.medicamentos?.[index]?.dataCaducidade?.message : ''}
                        onChange={e => {
                          field.onChange(e);
                          handleChange(index, 'dataCaducidade', e.target.value);
                        }}
                        value={medicamento.dataCaducidade}
                      />
                    )}
                  />
                </TableCell>
                <TableCell align="center" style={classes.tableCell}>
                  <Controller
                    name={`medicamentos.${index}.localCompra`}
                    control={control}
                    render={({ field }) => (
                      <TextField
                        {...field}
                        // label="Local de Compra"
                        fullWidth
                        // size="small"
                        variant="outlined"
                        error={!!errors?.medicamentos?.[index]?.localCompra}
                        helperText={typeof errors?.medicamentos?.[index]?.localCompra?.message === 'string' ? errors?.medicamentos?.[index]?.localCompra?.message : ''}
                        onChange={e => {
                          field.onChange(e);
                          handleChange(index, 'localCompra', e.target.value);
                        }}
                        value={medicamento.localCompra}
                      />
                    )}
                  />
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>

      <Button
        // style={{ background: '#85287e'}}
        variant="outlined"
        color="inherit"
        startIcon={<AddIcon />}
        onClick={adicionarLinha}
        style={classes.addButton}
      >
        Adicionar Medicamento
      </Button>
    </Box>
  );
}